import { render, staticRenderFns } from "./proyectoKanban.vue?vue&type=template&id=f5dd44fc&scoped=true&"
import script from "./proyectoKanban.vue?vue&type=script&lang=ts&"
export * from "./proyectoKanban.vue?vue&type=script&lang=ts&"
import style0 from "./proyectoKanban.vue?vue&type=style&index=0&id=f5dd44fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5dd44fc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCard,VIcon,VSpacer,VTextField,VToolbar,VToolbarTitle})
